import { createSceneReducer } from 'reducers/reducers-util';
import generalContractorsDataReducer from 'components/admin/general-contractors/store/reducers.data';
import generalContractorsUiReducer from 'components/admin/general-contractors/store/reducers.ui';

export default createSceneReducer(
  generalContractorsDataReducer,
  generalContractorsUiReducer
);
